import { queryKeys } from "@/lib/queryKeys";
import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import { useQuery } from "@tanstack/react-query";

const useLicenseCheck = () => {
    const { licenseManager } = useSdk();

    const { data: hasValidLicense, isLoading } = useQuery({
        queryKey: queryKeys.licenseCheck(),
        queryFn: async () => {
            try {
                // Pas de redirection ici : quand la licence est invalide,
                // CheckLicense rend NoLicenseScreen (écran dédié avec message spécifique).
                return licenseManager.hasValidLicense();
            } catch (error) {
                console.error("Error checking license:", error);
                throw error;
            }
        },
    });

    return { hasValidLicense, isLoading };
};

export default useLicenseCheck;
